import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GroupComponent} from './group.component';
import {GroupListComponent} from './group-list/group-list.component';
import {GroupDetailComponent} from './group-detail/group-detail.component';
import {GroupNewDialogComponent} from './group-new-dialog/group-new-dialog.component';
import {DeviceAddDialogComponent} from './device-add-dialog/device-add-dialog.component';

import {SharedModule} from '../../shared/shared.module';
import {MemberMgmtDialogComponent} from './member-mgmt-dialog/member-mgmt-dialog.component';

import {TabsModule, ToggleModule} from '../../vision';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ToggleModule,
    TabsModule
  ],
  declarations: [
    DeviceAddDialogComponent,
    GroupComponent,
    GroupDetailComponent,
    GroupListComponent,
    GroupNewDialogComponent,
    MemberMgmtDialogComponent
  ],
  entryComponents: [
    DeviceAddDialogComponent,
    GroupComponent,
    GroupNewDialogComponent,
    MemberMgmtDialogComponent
  ]
})
export class GroupModule { }
